<template>
  <div>
    <div
      ref="fotoPortadaRef"
      class="fotoportada-container"
    >
      <div class="overlay">

        <div class="mis-xv-wrapper-fixed">
          <img
            src="@/assets/corona.png"
            alt="Ornamento"
            class="ornamento-img floating"
          >

          <div class="nombre-wrapper">
            <div ref="kendraRef" class="nombre-kendra">Isabella Zorrilla</div><br>
            <div ref="cuevasRef" class="nombre-cuevas"></div>
          </div>
        </div>

        <div ref="fechaRef" class="fecha-evento">
          <span class="fecha-dia"></span>
          <span class="fecha-separador"></span>
          <span class="fecha-mes"></span>
          <span class="fecha-separador"></span>
          <span class="fecha-anio"></span>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import gsap from 'gsap'

export default {
  name: 'NavbarComponent',
  setup() {
    const fotoPortadaRef = ref(null)
    const kendraRef = ref(null)
    const cuevasRef = ref(null)
    const fechaRef = ref(null)

    onMounted(() => {
      const observer = new IntersectionObserver(
        ([entry], obs) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          // Foto visible desasdasdasdasdasdasdasdasdasddsasdasdasdasdasdadasdasdde el inicio, solo anima escala y posición
          tl.from(fotoPortadaRef.value, {
            scale: 1.08,
            y: 40,
            duration: 1.3
          })

          tl.from(kendraRef.value, {
            opacity: 0,
            y: 30,
            duration: 0.9
          }, '-=0.4')

          tl.from(cuevasRef.value, {
            opacity: 0,
            y: 40,
            duration: 1
          }, '-=0.6')

          tl.to(fechaRef.value.children, {
            opacity: 1,
            y: 0,
            duration: 0.9,
            stagger: 0.15
          }, '-=0.3')

          obs.unobserve(entry.target)
        },
        { threshold: 0.15 }
      )

      if (fotoPortadaRef.value) observer.observe(fotoPortadaRef.value)
    })

    return {
      fotoPortadaRef,
      kendraRef,
      cuevasRef,
      fechaRef
    }
  }
}
</script>

<style scoped>
.fotoportada-container {
  position: relative;
  width: 100%;
  height: 90vh;
  margin-top: -60px;
  overflow: hidden;
  /* Foto visible por defecto */
  background-image:
    linear-gradient(to bottom, rgba(24, 24, 24, 0.694), rgba(0, 0, 0, 0.066)),
    url('@/assets/IMG_9608.webp');
  background-size: cover;
  margin-bottom: -60px;
  background-position: top center;
}

/* NOMBRE POSICIONADO ARRIBA */
.mis-xv-wrapper-fixed {
  position: absolute;
  top: 80px; /* Cambiado de bottom a top */
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  z-index: 3;
}

.ornamento-img {
  width: 40px;
  filter: brightness(0) invert(1);
  margin-bottom: 4px;
}

.nombre-wrapper {
  text-align: center;
  
}

.nombre-kendra {
  font-family: 'cursivatitulo', serif;
  font-size: 52px;
  line-height: 1;
}

.nombre-cuevas {
  font-family: 'british';
  font-size: 30px;
  line-height: 1;
  margin-top: -4px;
}

/* FECHA SE MANTIENE ABAJO */
.fecha-evento {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'Karla', sans-serif;
  color: white;
  font-size: 18px;
  letter-spacing: 3px;
  display: flex;
  gap: 10px;
}

.fecha-evento span {
  opacity: 0;
  transform: translateY(20px);
}
</style>